module.exports = __webpack_public_path__ + "media/27.7785e779.mp3";